/**
 * DevExtreme (esm/__internal/core/utils/date.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const addOffsets = (date, offsets) => {
  const newDateMs = offsets.reduce((result, offset) => result + offset, date.getTime());
  return new Date(newDateMs);
};
const isValidDate = date => Boolean(date && !isNaN(new Date(date).valueOf()));
export const dateUtilsTs = {
  addOffsets: addOffsets,
  isValidDate: isValidDate
};